// get_post
export const GET_POST = 'get_post';
export const GET_POST_SUCCESSFUL = 'get_post_successfull';
export const GET_POST_FAILED = 'get_post_failed';

// create_post
export const CREATE_POST = 'create_post';
export const CREATE_POST_SUCCESSFUL = 'create_post_successfull';
export const CREATE_POST_FAILED = 'create_post_failed';

// update_post
export const UPDATE_POST = 'update_post';
export const UPDATE_POST_SUCCESSFUL = 'update_post_successfull';
export const UPDATE_POST_FAILED = 'update_post_failed';

// delete_post
export const DELETE_POST = 'delete_post';
export const DELETE_POST_SUCCESSFUL = 'delete_post_successfull';
export const DELETE_POST_FAILED = 'delete_post_failed';
